// Re-export style utilities from their new location
import { clsx, type ClassValue } from 'clsx';
import { 
  buttonVariants, 
  buttonSizes, 
  badgeVariants, 
  badgeBase, 
  cardStyles, 
  inputStyles, 
  statusColors 
} from '../styles/components';

// Class name utility
export function cn(...inputs: ClassValue[]): string {
  return clsx(inputs);
}

// Date/time formatting
export function formatDate(dateString: string): string {
  return new Date(dateString).toLocaleDateString('en-GB', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
}

// Number formatting
export function formatPercentage(value: number): string {
  return `${(value * 100).toFixed(1)}%`;
}

// Validation
export function isValidEmail(email: string): boolean {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

// String utilities
export function getInitials(firstName: string, lastName: string): string {
  return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
}

// Style helper functions
export function getButtonClasses(
  variant: keyof typeof buttonVariants = 'primary',
  size: keyof typeof buttonSizes = 'md',
  className?: string
): string {
  return cn(buttonVariants[variant], buttonSizes[size], className);
}

export function getBadgeClasses(
  variant: keyof typeof badgeVariants = 'gray',
  className?: string
): string {
  return cn(badgeBase, badgeVariants[variant], className);
}

export function getCampaignStatusColor(status: string): string {
  return statusColors[status as keyof typeof statusColors] || statusColors.draft;
}

// Re-export style constants for backward compatibility
export { buttonVariants, buttonSizes, badgeVariants, cardStyles, inputStyles };
export const cardClasses = cardStyles.base;
export const inputClasses = inputStyles.base;
